module.exports = __webpack_public_path__ + "static/media/panther-queen.281d91e8.gif";